import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
export var errorBoundaryFallbackStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: initial;\n"])));